module.exports = {"header":{"material":"Material","special":"Special","assambly":"Assambly"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/header.json
// module id = 542
// module chunks = 13